// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import axios from 'axios'
import Cookies from 'js-cookie'
import VueCookies from 'vue-cookies'

import Vant from 'vant'
import 'vant/lib/index.css'

import VueAMap from 'vue-amap'

import preview from 'vue-photo-preview';
import 'vue-photo-preview/dist/skin.css';
Vue.use(preview);

Vue.use(Vant)

// 全局引入 mock api，这一行是有作用的，请勿删除
import mock from '@/mock/index.js'

Vue.use(VueCookies)
Vue.use(ElementUI)
Vue.prototype.$axios = axios
Vue.use(VueAMap)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: (h) => h(App),
  components: {
    App,
  },
  template: '<App/>',

  created() {
    this.getLoginUser();
  },
  methods: {
    getLoginUser: function () {
      //在页面刷新时将vuex里的信息保存到localStorage里
      window.addEventListener('beforeunload', () => {
        localStorage.setItem('users', JSON.stringify(this.$store.state));
      });
      //在页面加载时读取localStorage里的状态信息
      localStorage.getItem('users') &&
      this.$store.replaceState(
        Object.assign(
          this.$store.state,
          JSON.parse(localStorage.getItem('users')),
        ),
      );
    },
  }

})

window.addEventListener('beforeunload', function (e) {
  // Cookies.remove('isLogin')
})

VueAMap.initAMapApiLoader({
  key: '61962f396266d21f0001fddc52f78a9fy',
  plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor','AMap.Geolocation',],
  // 默认高德 sdk 版本为 1.4.4
  v: '1.4.4'
})



// WEBPACK FOOTER //
// ./src/main.js